import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import PhoneField from '../PhoneField'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * key to save the formatted value in Formik
   */
  idFormatted: PropTypes.string,
}

/**
 * Connects the PhoneField with Formik
 */
function FormikPhoneField(props) {
  const { id, idFormatted = null } = props ?? {}

  return (
    <Field name={id}>
      {({ field, meta, form }) => (
        <PhoneField
          {...props}
          id={id}
          name={id}
          onChange={(value, countryData, event, formattedValue) => {
            form.setFieldValue(id, value)
            // react-phone-input-2 provides no method of formatting the value outside the component
            // so if 'idFormatted' is passed, saves the formatted value in it
            if (idFormatted) {
              form.setFieldValue(idFormatted, formattedValue)
            }
          }}
          value={field.value}
          errors={meta.touched && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikPhoneField.propTypes = propTypes

export default FormikPhoneField
